<a
  class="web-menu-button"
  [ngClass]="{
    'web-menu-button--selected': isSelected(),
  }"
  [routerLink]="link()"
>
  <ng-content></ng-content>
</a>
